import { type CollapsiblePanelNames } from '../../../queries/schema/carFinance.schema';
import { CollapsiblePanels } from '../../shared/PanelContext.typed';
import { typeSafeObjectKeys } from '@dist-marketplace-frontend/utils';

const findNextInvalidPanelKey = (
  obj: CollapsiblePanels,
  startKey: CollapsiblePanelNames,
) => {
  const keys = typeSafeObjectKeys(obj);
  const startIndex = keys.indexOf(startKey);

  if (startIndex === -1 || startIndex === keys.length - 1) {
    return null;
  }

  for (let i = startIndex + 1; i < keys.length; i++) {
    const currentKey = keys[i];
    const value = obj[currentKey];

    if (
      value &&
      typeof value === 'object' &&
      Object.prototype.hasOwnProperty.call(value, 'isValid') &&
      value.isValid === false
    ) {
      return currentKey;
    }
  }

  return null;
};

export { findNextInvalidPanelKey };
